import { prop } from "../../decorators/property";
export class ReportDetailModel extends Backbone.AssociatedModel {

    @prop() public PdfLink: string;
    @prop() public ReportName: string;
    @prop() public PdfStatus: number;
    @prop() public Source: string;
    @prop() public Reference: string;
    @prop() public Rank: number;

    constructor(options: any) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/report-detail.ts